import axios from "axios";

export default function EntrylogDailyreportDownloadService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + '/report/entry_location_daily_headcount',
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
};
